<template>
  <div>
    <!-- 头部 -->
    <Header :user="user" :isMobile="isMobile" @toggleDrawer="toggleDrawer"/>

    <!-- 主体 -->
    <div style="display: flex">
      <!-- PC端侧边栏 -->
      <Aside v-if="!isMobile" />
      
      <!-- 移动端抽屉侧边栏 -->
      <el-drawer
          v-model="drawerVisible"
          direction="ltr"
          :size="200"
          :with-header="false"
          v-if="isMobile"
      >
        <Aside @closeDrawer="closeDrawer" />
      </el-drawer>
      
      <!-- 内容区域 -->
      <router-view style="flex: 1" @userInfo="refreshUser"/>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Aside from "@/components/Aside";
import request from "@/utils/request";

export default {
  name: "Layout",
  components: {
    Header,
    Aside
  },
  data() {
    return {
      user: {},
      isMobile: false,
      drawerVisible: false
    }
  },
  created() {
    this.refreshUser();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    refreshUser() {
      let userJson = sessionStorage.getItem("user");
      if (!userJson) {
        return
      }
      let userId = JSON.parse(userJson).id
      // 从后台取出更新后的最新用户信息
      request.get("/user/" + userId).then(res => {
        this.user = res.data
      })
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },
    closeDrawer() {
      this.drawerVisible = false;
    }
  }
}
</script>

<style scoped>
</style>
